import React from 'react'
import { Page, Content, EmptyState } from '@insticator/insticator-ui'
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/portedtobeta/portedtobeta_styles';

const PortedToBeta = props => {

  const { buttonText, body, handleButtonClick, path } = props

  const redirectToUsersV2 = () => window.open(`https://publisher-portal.${url.baseURL}/${path}`, '_self')

  return (
    <Page name={`portedtobeta`} klass={props.classes.portedtobeta}>
      <Content>
        <EmptyState 
          graphicName={'error-404'} 
          buttonText={buttonText} 
          bodycopy={body} 
          buttonClick={redirectToUsersV2} 
          buttonName={'gotoppv2users'}
        />
      </Content>
    </Page>
  )

}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PortedToBeta);